<script>
    export let title;
</script>

<div class="header-text panel-layout-color">{title}</div>

<style>
    div {
        position: relative;
        display: inline-block;
        padding: 12px 32px;
        border-radius: 20px;
    }
</style>
